import { render, staticRenderFns } from "./transferView.vue?vue&type=template&id=13a90e66&scoped=true"
import script from "./transferView.vue?vue&type=script&lang=js"
export * from "./transferView.vue?vue&type=script&lang=js"
import style0 from "./transferView.vue?vue&type=style&index=0&id=13a90e66&prod&lang=less&scoped=true"
import style1 from "./transferView.vue?vue&type=style&index=1&id=13a90e66&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a90e66",
  null
  
)

export default component.exports